import ModalComponent from '@/common/Modal';
import { Box, Button, Text } from '@chakra-ui/react';
import React from 'react'

export interface RemoveDomainConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
  onSaveClick: () => void;
}

const RemoveDomainConfirmation = ({ isOpen, onClose, onSaveClick }:RemoveDomainConfirmationProps) => {
  return (
    <ModalComponent
      title="Remove Domain Confirmation"
      isOpen={isOpen}
      onClose={onClose}
      variant={2}
      footer={
        <>
          <Button
            colorScheme="blue"
            background="#ffffff"
            color="#0C1E46"
            border="1px solid #0C1E46"
            padding="8px 11px"
            marginRight="20px"
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            background="#0C1E46"
            padding="8px 20px"
            onClick={onSaveClick}
          >
            Remove
          </Button>
        </>
      }
    >
        <Box className='remove-domain-body'>
            <Text>Removing a store domain can break your FFL checkout integration. Are you sure?</Text>
        </Box>
    </ModalComponent>
  )
}

export default RemoveDomainConfirmation